export default function* constantL(a) { yield a; }